<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <ComponentsFixedBar :minimized-side-menu="minimizedSideMenu" :title="$t('general.setResponsible')"/>
      </v-col>

      <v-col class="px-2 pb-0 d-flex justify-center" cols="12" style="padding-top: 50px">
        <v-autocomplete
          class="pa-5"
          color="kbDarkBlueText"
          :items="administrators"
          item-text="fullName"
          item-value="userId"
          :label="$t('general.pickAResponsible')"
          outlined
          :search-input.sync="search"
          style="max-width: 500px"
          v-model="responsibleId"
        />
      </v-col>

      <v-col cols="12" class="d-flex justify-center pt-0">
        <v-btn :color="mainColor"
               dark
               :loading="editingUser"
               @click="submit()">
          {{ $t('general.saveChanges') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import ComponentsFixedBar from '@/pages/App/People/dialogs/ViewUser/ComponentsFixedBar'
export default {
  components: { ComponentsFixedBar },
  computed: {
    ...mapGetters(['administrators']),
    ...mapState({
      selectedUser: state => state.users.selectedUser
    })
  },
  async created () {
    this.$store.commit('SET_PAGINATION_USERS_COMPANY', {
      page: 1,
      itemsPerPage: 300,
      sortBy: [],
      sortDesc: []
    })
    await this.getAdministrators()
    this.setUserResponsible()
  },
  data () {
    return {
      editingUser: false,
      responsibleId: '',
      rules,
      search: ''
    }
  },
  methods: {
    async getAdministrators () {
      try {
        await this.$store.dispatch('getAdministrators', this.search)
      } catch (e) {
        notifications.error(e)
      }
    },
    getUser () {
      this.$emit('getUser')
    },
    onResponsibleChange (userId) {
      this.responsibleId = userId
    },
    setUserResponsible () {
      this.search = ''
      this.responsibleId = this.selectedUser.responsibleId || ''
    },
    async submit () {
      if (this.editingUser) return
      if (!this.$refs.form.validate()) return
      try {
        this.editingUser = true
        await this.$store.dispatch('updateUser', {
          userId: this.selectedUser.userId,
          responsibleId: this.responsibleId
        })
        this.getUser()
        notifications.success('Responsible successfully changed')
        this.editingUser = false
      } catch (e) {
        notifications.error(e.message)
        this.editingUser = false
      }
    }
  },
  props: {
    mainColor: {
      type: String
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    }
  }
}
</script>
